import React, { useEffect, useState } from "react";
import { getallapplicant, reset } from "../../features/Applicant/applicantSlice";
import { useAppDispatch, useAppSelector } from "../../useStore";
import HiredTable from "./ApplicantTableComponent/HiredTable";
import swal from "sweetalert";


const ApplicantHired = () => {
  const [resetID, setResetID] = useState(false)
  const dispatch = useAppDispatch();
  const [status, setStatus] = useState("HIRED"); // State to store the selected value

  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess ||
      EditapplicantionisSuccess ||
      sendForTranningisSuccess ||
      updateTranningisSuccess
    ) {
      const input = { applicationStatus: "HIRED" };
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, dispatch, UpdateOfferisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, sendForTranningisSuccess, updateTranningisSuccess]);

  useEffect(() => {
    const input = { applicationStatus: status };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [dispatch, status]);

  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])



  return (
    <div>
      <HiredTable
        statusButton={"view-HIRED-profile"}
        pageHeader={"Hired"}
        placeholder={"Hired & RESIGNED"}
        Status={"HIRED"}
        headerTitles={[
          "Edit",
          "Applicant Name",
          "Gender",
          "Date Of Birth",
          "Job Profile",
          "View ID",
          "Applied on",
          "Status",
          "Email",
          "Phone Number",
          "Average Interview Score",
          "Work Experience",
          "Relevant Work Experience",
          "Location",
          "Edit",
          "Starting Date",
        ]}
        data={data}
        message={message}
        isError={isError}
        isLoading={isLoading}
        setResetID={setResetID}
        setStatus={setStatus}
        status={status}
      />
    </div>
  );
};
export default ApplicantHired;       